import React, { FC, useEffect, useState, useRef } from 'react'
import { BorderedPageLayout } from '../../../pages/BorderedPageLayout'
import { FlashON, FlashOFF, QRSuccess, CameraError } from '../../../icons'
import { handleQRScannerModal} from '../../../features/modals/modalsSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { getByHash } from '../../../features/profile/profileSlice'
import {message } from 'antd';
import {encodeURL, decodeURL} from '../../../utils/hashURLData'
import useTheme from '../../../hooks/useAppColor'
import { ModalContentProps } from '../../Modal'
import { useNavigate } from 'react-router-dom'
// @ts-ignore
import Quagga from 'quagga';
import jsQR from 'jsqr'
import './QRStyle.css'
import { NoticeType } from 'antd/es/message/interface'

declare class ImageCapture {
  constructor(track: MediaStreamTrack);
  setOptions(options: { focusMode?: string }): Promise<void>;
}

export const  QRScannerModalContent: FC<ModalContentProps> = ({ handleModal, level }) => {
    const dispatch = useAppDispatch()
    const getTheme = useTheme()
    const navigate = useNavigate()

    const [facingMode, setFacingMode] = useState<'user' | 'environment'>('environment');
    const [resData, setResData] = useState<string>('');
    const [isScanning, setIsScanning] = useState<boolean>(false);
    const [isFlashOn, setIsFlashOn] = useState<boolean>(false);
    const [cameraError, setCameraError] = useState<string>('')
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const streamRef = useRef<MediaStream | null>(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const imageCaptureRef = useRef<ImageCapture | null>(null);
    const {id} = useAppSelector(state => state.agent)

    const [messageApi, contextHolder] = message.useMessage();

    const showMessage = (type: NoticeType, content: string) => {
      messageApi.open({
        type: type,
        content: content,
        duration: 5
      });
    };

    // Функция для запуска сканирования
    const startScan = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode }
        });
        
        handleAutoFocus()

        streamRef.current = stream;
  
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
          setIsScanning(true);
  
          // Инициализация QuaggaJS для штрих-кодов
          Quagga.init(
            {
              inputStream: {
                name: 'Live',
                type: 'LiveStream',
                target: videoRef.current,
                constraints: {
                  facingMode: facingMode,
                },
              },
              decoder: {
                readers: ['code_128_reader', 'ean_reader', 'upc_reader', 'ean_8_reader', 'code_39_reader', 'code_39_vin_reader', 'codabar_reader', 'upc_reader', 'upc_e_reader', 'i2of5_reader', '2of5_reader', 'code_93_reader'], // Типы штрих-кодов
              },
            },
            (err: any) => {
              if (err) {
                console.error('Quagga initialization failed:', err);
                return;
              }
              Quagga.start();
            }
          );
  
          // Обработка распознанных штрих-кодов
          Quagga.onDetected((result: any) => {
            const code = result.codeResult.code;
            setResData(code);
            stopScan();
          });
  
          // Запуск сканирования QR-кодов с использованием jsQR
          const track = stream.getVideoTracks()[0];
          imageCaptureRef.current = new ImageCapture(track);
          
          requestAnimationFrame(scanFrame);
        }
      } catch (error) {
        setCameraError("Невозможно получить доступ к камере!")
      }
    };

    // Сканирование кадра для QR-кодов
    const scanFrame = () => {
      
      if (!isScanning) return;
      
      const video = videoRef.current;
      const canvas = canvasRef.current;
      
      if (video && canvas && video.readyState === video.HAVE_ENOUGH_DATA) {
        const context = canvas.getContext('2d', { willReadFrequently: true });
        
        if(context){
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          context.drawImage(video, 0, 0, canvas.width, canvas.height);
          const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
          const code = jsQR(imageData.data, imageData.width, imageData.height);
          if (code) {
            
          alert(code.data)
            
          try{
            const searchURL = new URL(code.data)
            const discountParams: any = searchURL.searchParams.get('discount')

            if(discountParams !== null ){
              
              dispatch(getByHash(discountParams))
              showMessage('success', 'Скидка успешно применена к вашему заказу')
              dispatch(handleQRScannerModal())
            }
            }
            catch(error){
              console.log("При попытке создать URL: ", error)
            }

            
            } else {
              requestAnimationFrame(scanFrame);
            }
        }
      }
      else {
        requestAnimationFrame(scanFrame);
      }
    }
  
    // Остановка сканирования
    const stopScan = () => {

      setIsScanning(false);
  
      if (videoRef.current && videoRef.current.srcObject) {
        const stream = videoRef.current.srcObject as MediaStream;
        stream.getTracks().forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }
  
      // Остановка QuaggaJS
      Quagga.stop();
    };

  
    // Включение/выключение вспышки
    const toggleFlash = async () => {
      if (streamRef.current) {
        const track = streamRef.current.getVideoTracks()[0];
        try {
          await track.applyConstraints({
            advanced: [{ torch: !isFlashOn }] as any
          });
          setIsFlashOn(!isFlashOn);
        } catch (error) {
          console.error('Failed to toggle flash:', error);
        }
      }
    };
  
    // Автофокус
    const handleAutoFocus = async () => {
      if (streamRef.current) {
        const track = streamRef.current.getVideoTracks()[0];
        try {
          await track.applyConstraints({
            advanced: [{ focusMode: 'continuous' }] as any
          });
        } catch (error) {
          console.error('Failed to set auto focus:', error);
        }
      }
    };
  
    useEffect(() => {
      if (videoRef.current) {
        setIsScanning(true)
        startScan();
      }
  
      // Очистка при размонтировании
    }, [videoRef.current]);

  
    return (
      <BorderedPageLayout
        modal={{ level: 1 }}
        handleModal={() => {}}
        contentClassName='f-column gap-40'>
        {contextHolder}
        <div className="d-f jc-between">
          <div onClick={handleModal} className="textButton fz-l">Закрыть</div>
          <div className='f-025'></div>
        </div>
        <div className="f-column gap-30">

          <div className={`video-container ${getTheme("light", "dark")}`}>
            <button onClick={toggleFlash}>{!isFlashOn ? < FlashON /> : <FlashOFF/>}</button>
            <video
              ref={videoRef}
            muted></video>
            <div className="scan-overlay">
              <div className="scan-line"></div>
            </div>
          </div>
          <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
          { cameraError &&
            <div className={`big-btn whiteBorderedBlock ${getTheme("", "app-bg-dark")} f-c-col gap-15 w-100p`}>
                <CameraError />
                <p className={`${getTheme("c-black", "c-white")} txt-center fw-5 fz-m`}>{cameraError}</p>
            </div>   
          }
        </div>
      </BorderedPageLayout>
    );
}
